import {SET_MIX_EVENTS} from 'constants/action-types.js';
import {SET_SELECTED_ARRANGEMENT_EVENTS} from 'constants/action-types.js';
import {SET_ARRANGEMENT_MOUSE_X} from 'constants/action-types.js';
import {SET_ARRANGEMENT_MOUSE_DOWN_X} from 'constants/action-types.js';
import {SET_ARRANGEMENT_SELECTION} from 'constants/action-types.js';
import {SET_ARRANGEMENT_AUTOMATION_TO_SHOW} from 'constants/action-types.js';
import {SET_ARRANGEMENT_LOOPING} from 'constants/action-types.js';
import {SET_ARRANGEMENT_SELECTED_ROWS} from 'constants/action-types.js';
import {SET_ARRANGEMENT_LOOP_SELECTED} from 'constants/action-types.js';
import {SET_ARRANGEMENT_ROW_SELECTIONS} from 'constants/action-types.js';
import {SET_ARRANGEMENT_X_SCALE} from 'constants/action-types.js';
import {SET_TOTAL_ARRANGEMENT_LENGTH} from 'constants/action-types.js';
import {SET_ARRANGEMENT_BOTTOM_HEIGHT} from 'constants/action-types.js';
import {SET_ARRANGEMENT_BOTTOM_MODE} from 'constants/action-types.js';
import {SET_ARRANGEMENT_BOTTOM_RESIZING} from 'constants/action-types.js';
import {SET_ARRANGEMENT_PATTERN_DRAGGING} from 'constants/action-types.js';
import {SET_ARRANGEMENT_PATTERN_START_STEP} from 'constants/action-types.js';
import {SET_ARRANGEMENT_CURSOR_STEP} from 'constants/action-types.js';
import {SET_ARRANGEMENT_PATTERN_RESIZING} from 'constants/action-types.js';
import {SET_ARRANGEMENT_BROWSER_MODE} from 'constants/action-types.js';
import {SET_BOTTOM_TOOLBAR_OFFSET} from 'constants/action-types.js';
import {SET_SHOW_ARRANGEMENT_TRACKS} from 'constants/action-types.js';
import {SET_ARRANGEMENT_PATTERN_SELECTED} from 'constants/action-types.js';
import {SET_SHOW_ARRANGEMENT_SEARCHER} from 'constants/action-types.js';
import {PIANO_ROLL, EFFECTS, INFO, MODE_TO_HEIGHT} from 'constants/arrangement-modes.js';
import {FOLDERS} from 'constants/arrangement-browser-modes.js';

let initialState = {
    totalLength: 120,
    browserMode: FOLDERS,
    bottomHeight: 400,
    bottomMode: PIANO_ROLL,
    patternDragging: undefined,
    patternResizing: undefined,
    showSearcher: false,
    isBottomResizing: false,
    bottomOffset: 0,
    patternStartSteps: {},
    loopSelected: false,
    mixEvents: {},
    xScale: 0.25,
    selectedEvents: undefined,
    selection: {
        start: 0,
        end: 64,
    },
    looping: false, // whether sequencer loops using the selection
    mouseX: undefined, // quantized x position of mouse helper
    mouseDownX: 0, // quantized x position of mouse helper
    automationTypeToShow: {}, // mapping from row -> type of automation (like volume, pattern, etc)
    selectedRows: [], // which rows are fully selected
    rowSelections: {},  // mapping from row -> start, end point of selection
    cursorStep: undefined,
    showTracks: {},
    patternSelected: undefined
};

const arrangementReducer = (state = initialState, action) => {
    let newState;
    switch (action.type) {
    case SET_MIX_EVENTS:
        let mixEvents = {... state.mixEvents};
        let subEvents = mixEvents[action.payload.subSequenceId] || {};
        subEvents[action.payload.type] = action.payload.events;
        mixEvents[action.payload.subSequenceId] = subEvents;
        return {
            ... state,
            mixEvents: mixEvents,
        };
    case SET_ARRANGEMENT_PATTERN_SELECTED:
        return {
            ... state,
            patternSelected: action.payload
        };
    case SET_TOTAL_ARRANGEMENT_LENGTH:
        return {
            ... state,
            totalLength: action.payload
        };
    case SET_SHOW_ARRANGEMENT_TRACKS:
        let showTracks = {... state.showTracks};
        showTracks[action.payload.subSequenceId] = action.payload.show;
        return {
            ... state,
            showTracks
        };
    case SET_SHOW_ARRANGEMENT_SEARCHER:
        return {
            ... state,
            showSearcher: action.payload
        };
    case SET_ARRANGEMENT_AUTOMATION_TO_SHOW:
        let automationToShow = {... state.automationTypeToShow};
        automationToShow[action.payload.subSequenceId] = action.payload.type;
        return {
            ... state,
            automationTypeToShow: automationToShow,
        };
    case SET_SELECTED_ARRANGEMENT_EVENTS:
        return {
            ... state,
            rowSelections: action.payload === undefined ? state.rowSelections : {},
            selectedEvents: action.payload,
        };
    case SET_ARRANGEMENT_SELECTION:
        if (action.payload.start === undefined) {
            return {
                ... state,
                selection: undefined
            };
        }
        return {
            ... state,
            selection: {
                start: action.payload.start,
                end: action.payload.end,
            }
        };
    case SET_ARRANGEMENT_ROW_SELECTIONS:
        return {
            ... state,
            // selectedEvents: action.payload === undefined ? state.selectedEvents : undefined,
            rowSelections: {... action.payload}
        };
    case SET_ARRANGEMENT_MOUSE_X:
        return {
            ... state,
            mouseX: action.payload
        };
    case SET_ARRANGEMENT_MOUSE_DOWN_X:
        return {
            ... state,
            mouseDownX: action.payload
        };
    case SET_ARRANGEMENT_LOOPING:
        return {
            ... state,
            looping: action.payload
        };
    case SET_ARRANGEMENT_LOOP_SELECTED:
        return {
            ... state,
            loopSelected: action.payload
        };
    case SET_ARRANGEMENT_SELECTED_ROWS:
        return {
            ... state,
            selectedRows: action.payload,
        };
    case SET_ARRANGEMENT_X_SCALE:
        return {
            ... state,
            xScale: action.payload,
        };
    case SET_ARRANGEMENT_BOTTOM_HEIGHT:
        return {
            ... state,
            bottomHeight: action.payload,
        };
    case SET_ARRANGEMENT_BOTTOM_MODE:
        // let height = MODE_TO_HEIGHT(action.payload);
        return {
            ... state,
            bottomMode: action.payload,
            // bottomHeight: height !== undefined ? height : 0,
        };
    case SET_ARRANGEMENT_BOTTOM_RESIZING:
        return {
            ... state,
            isBottomResizing: action.payload,
        };
    case SET_ARRANGEMENT_PATTERN_DRAGGING:
        return {
            ... state,
            patternDragging: action.payload
        };
    case SET_ARRANGEMENT_PATTERN_RESIZING:
        return {
            ... state,
            patternResizing: action.payload
        };
    case SET_ARRANGEMENT_PATTERN_START_STEP:
        let patternStartStep = state.patternStartSteps[action.payload.subSequenceId] || {} ;
        patternStartStep[action.payload.patternId] = action.payload.startStep;
        let patternStartSteps = state.patternStartSteps;
        patternStartSteps[action.payload.subSequenceId] = patternStartStep;
        return {
            ... state,
            patternStartSteps: patternStartSteps
        };
    case SET_ARRANGEMENT_CURSOR_STEP:
        return {
            ... state,
            cursorStep: action.payload
        };
    case SET_ARRANGEMENT_BROWSER_MODE:
        return {
            ... state,
            browserMode: action.payload
        };
    case SET_BOTTOM_TOOLBAR_OFFSET:
        return {
            ... state,
            bottomOffset: action.payload
        };
    default:
        return state;
    }
};

export default arrangementReducer;
